import { Element } from "@xmpp/xml"
import type { Feature, Polygon } from "geojson"

export type AvoidanceItems = {
  features: Feature<Polygon>[]
  type: "FeatureCollection"
}

export default class AvoidanceItemsParser {
  static parse(stanza: Element): AvoidanceItems | undefined {
    if (
      stanza.name !== "iq" ||
      !stanza.getAttr("from") ||
      !stanza.getAttr("to")
    )
      return

    const command = stanza.getChild(
      "command",
      "http://jabber.org/protocol/commands",
    )
    if (!command) return

    const json = command.getChild("json", "urn:xmpp:json:0")
    if (!json) return
    let avoidanceItems: { geojson: AvoidanceItems } | undefined = undefined
    try {
      avoidanceItems = JSON.parse(json!.text())
    } catch {
      console.log("Invalid JSON format in DriverPolyline")
    }

    return avoidanceItems?.geojson
  }
}
